import { useEffect, useState } from "react";

import { IImageReference } from "../../@types/Note";
import {
  TooltipContainer,
  TooltipImage,
  TooltipLoading,
  TooltipError,
  TooltipLabel,
} from "./ImageReferenceTooltip.styles";

interface IImageReferenceTooltipProps {
  imageKey: string;
  displayOrder: number;
  images: IImageReference[];
  position: { x: number; y: number };
  onClose: () => void;
}

export function ImageReferenceTooltip({
  imageKey,
  displayOrder,
  images,
  position,
  onClose,
}: IImageReferenceTooltipProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const image = images.find((img) => img.key === imageKey);

  useEffect(() => {
    if (!image) {
      setHasError(true);
      setIsLoading(false);
    }
  }, [image]);

  const handleImageLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  if (!image) {
    return (
      <TooltipContainer style={{ top: position.y, left: position.x }}>
        <TooltipError>Image not found</TooltipError>
      </TooltipContainer>
    );
  }

  return (
    <TooltipContainer
      style={{ top: position.y, left: position.x }}
      onMouseLeave={onClose}
    >
      <TooltipLabel>Image {displayOrder}</TooltipLabel>

      {isLoading && <TooltipLoading>Loading...</TooltipLoading>}

      {hasError && <TooltipError>Failed to load image</TooltipError>}

      <TooltipImage
        src={image.preSignedUrl}
        alt={`Image ${displayOrder}`}
        onLoad={handleImageLoad}
        onError={handleImageError}
        style={{ display: isLoading || hasError ? "none" : "block" }}
      />
    </TooltipContainer>
  );
}
